/**
 * Ajax-клиент витрины: POST JSON на /ajax/{zone}/{action}, ответ в
 * формате ControllerCommon ({ status, code, data }). Ошибка сервера
 * превращается в исключение с переведённым сообщением.
 */
const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
};

async function request( method, path, body = null ) {

    const url = window.baseURL + '/ajax/' + path.replace( /^\/+/, '' );

    const options = {
        method,
        headers,
        credentials: 'same-origin',
    };

    if( body !== null && method !== 'GET' )
        options.body = JSON.stringify( body );

    let response;

    try {
        response = await fetch( url, options );
    } catch( e ) {
        throw new Error( window.i18n?.['common.error'] || 'Network error' );
    }

    let json = {};

    try {
        json = await response.json();
    } catch( e ) {}

    if( json.status !== 'success' ) {

        const message = json.data?.message || window.i18n?.['common.error'] || 'Error';
        const error   = new Error( message );

        error.code = json.code || response.status;
        error.data = json.data || {};

        throw error;
    }

    return json.data || {};
}

export const api = {
    get: ( path, params = {} ) => {

        const query = new URLSearchParams( params ).toString();

        return request( 'GET', path + ( query ? '?' + query : '' ) );
    },
    post: ( path, body = {} ) => request( 'POST', path, body ),
};
